import { InjectionToken } from '@angular/core';

import { SharedHttpService } from './shared-http.service';
import { SharedHttpServiceConfig } from './shared-http-service-config.interface';

export const SHARED_HTTP_SERVICE_TOKEN = new InjectionToken<SharedHttpService>('SHARED_HTTP_SERVICE_TOKEN');
export const SHARED_HTTP_SERVICE_CONFIG_TOKEN = new InjectionToken<SharedHttpServiceConfig>(
  'SHARED_HTTP_SERVICE_CONFIG_TOKEN',
);
